import React from 'react';
import {useParams} from 'react-router-dom';
import useFilterModalContext from '../../useFilterModalContext';
import useSearchParams from '../../../../useSearchParams';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';
import {useLeadSourcesQuery} from 'api';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {query, setQuery} = useSearchParams();
  const {poolId} = useParams<{poolId: string}>();

  const {data: {leadSources = []} = {}} = useLeadSourcesQuery({
    variables: {uuid: poolId},
    skip: !poolId,
    fetchPolicy: 'cache-and-network',
  });

  if (!query?.leadSourceIds || !query.leadSourceIds.length) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">最新リードソース</h4>
        <button
          onClick={() => setFilterType('leadSource')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() => setQuery({...query, leadSourceIds: []})}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex gap-1">
        <div className="flex flex-wrap items-center">
          {query.leadSourceIds.includes('0') && (
            <span className="mr-1.5 mb-1.5 text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
              未設定
            </span>
          )}
          {leadSources
            .filter((leadSource) => query.leadSourceIds.includes(leadSource.id))
            .map((leadSource) => (
              <span
                key={leadSource.id}
                className="mr-1.5 mb-1.5 text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
                {leadSource.name}
              </span>
            ))}
        </div>
      </div>
    </div>
  );
};
